const normalize = (val) => String(val).trim().toLowerCase();

export function isValidName(firstName = '', lastName = '') {
	if (!firstName || !lastName) {
		return true;
	}

	return normalize(firstName) !== normalize(lastName);
}
